import { Node, nodePasteRule } from '@tiptap/vue-3';

/**
 * IFrame tag node
 */
export const IFrameExtension = Node.create({
  name: 'iframe',
  group: 'block',
  content: 'text*',
  draggable: true,
  atom: true,

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  parseHTML() {
    return [
      {
        tag: 'iframe',
      },
    ];
  },

  addPasteRules() {
    return [
      nodePasteRule({
        find: (text) => {
          if (!text.startsWith('<iframe')) {
            return null;
          }

          const div = document.createElement('div');
          div.innerHTML = text;
          const iframe = div.querySelector('iframe');

          if (!iframe) {
            return null;
          }

          const iframeAttrs = iframe.getAttributeNames() ?? [];

          const data = iframeAttrs.reduce<Record<string, string | null>>((acc, key) => ({
            ...acc,
            [key]: iframe.getAttribute(key),
          }), {});

          return [{
            index: 0,
            text,
            data,
          }];
        },
        type: this.type,
        getAttributes: (match) => match.data,
      }),
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['iframe', HTMLAttributes, 0 ];
  },
});
